export const logo = ['608 134', `
<title>Quick</title>

<g>
 <text transform="matrix(3.81805 0 0 2.30969 -346.974 -352.337)" stroke="#000" font-style="normal" font-weight="normal" xml:space="preserve" text-anchor="start" font-family="'Anton'" font-size="24" id="svg_22" y="184.20407" x="95.03598" stroke-width="0" fill="#4c4c4c">QUICK</text>
 <text font-weight="normal" transform="matrix(2.84485 0 0 2.84485 -751.881 -466.164)" stroke="#000" xml:space="preserve" text-anchor="start" font-family="'Montserrat'" font-size="24" id="svg_24" y="189.81179" x="340.31637" stroke-width="0" fill="#007fff">Manager</text>
</g>
`]
